import { render, staticRenderFns } from "./MainImageModal.vue?vue&type=template&id=b7861c62&scoped=true"
import script from "./MainImageModal.vue?vue&type=script&lang=ts"
export * from "./MainImageModal.vue?vue&type=script&lang=ts"
import style0 from "./MainImageModal.vue?vue&type=style&index=0&id=b7861c62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7861c62",
  null
  
)

export default component.exports